// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingIndicatorSmall_wrapper__VudyB","spinner":"LoadingIndicatorSmall_spinner__b1zHg","spin":"LoadingIndicatorSmall_spin___FEYr"};